import graphql__ca171af6eb26c11ecb69 from "./__generated__/Answers_answers.graphql.js";import { useMemo } from "react";
import { graphql, useFragment } from "react-relay";

import Answer from "./";
import { useFilterConditionnallyHiddenAnswers } from "./useFilterConditionnallyHiddenAnswers";

const Answers = props => {
  const answers = useFragment(Answers_answers, props.answers) || [];
  const { className, isCorrection, correctionTextOnlyOnWrongAnswers, resourceId } = props;

  const filteredAnswers = useFilterConditionnallyHiddenAnswers({ answers });

  // Builds answer groups by splitting the answers list into a new group when
  // it finds a separator
  //
  const answerGroups = useMemo(
    () =>
      filteredAnswers.reduce((answerGroups, answer) => {
        if (answer.isSeparator && answerGroups.length === 0) {
          return answerGroups;
        }

        if (answer.isSeparator || answerGroups.length === 0) {
          answerGroups.push({ id: answerGroups.length, answers: [] });
        }

        if (answer.isSeparator) {
          return answerGroups;
        }

        const answerGroup = answerGroups[answerGroups.length - 1];
        answerGroup.answers.push(answer);

        return answerGroups;
      }, []),
    [filteredAnswers]
  );

  if (!filteredAnswers.length) return null;

  return answerGroups.map(answerGroup => (
    <div key={answerGroup.id} className={className}>
      {answerGroup.answers.map(answer => (
        <Answer
          key={answer.id}
          isCorrection={isCorrection}
          correctionTextOnlyOnWrongAnswers={correctionTextOnlyOnWrongAnswers}
          resourceId={resourceId}
          answer={answer}
        />
      ))}
    </div>
  ));
};

const Answers_answers = graphql__ca171af6eb26c11ecb69;

export default Answers;
